/**
 * Extract a user-facing message from axios / DRF API errors.
 * Handles: detail, message, error, and field validation objects
 * e.g. { "email": ["employer user master with this email already exists."] }
 */
export const getApiErrorMessage = (error, fallback = "Something went wrong!") => {
  const data = error?.response?.data;

  if (!data) {
    return error?.message || fallback;
  }

  if (typeof data === "string") {
    return data;
  }

  const direct = data.detail ?? data.message ?? data.error;

  if (typeof direct === "string") {
    return direct;
  }

  if (Array.isArray(direct)) {
    const text = direct.filter((item) => typeof item === "string").join(" ");
    if (text) return text;
  }

  const fieldMessages = [];

  const collectMessages = (value) => {
    if (typeof value === "string") {
      fieldMessages.push(value);
      return;
    }
    if (Array.isArray(value)) {
      value.forEach(collectMessages);
      return;
    }
    if (value && typeof value === "object") {
      Object.values(value).forEach(collectMessages);
    }
  };

  if (data && typeof data === "object") {
    Object.entries(data).forEach(([key, value]) => {
      if (key === "detail" || key === "message" || key === "error") {
        return;
      }
      collectMessages(value);
    });
  }

  if (fieldMessages.length > 0) {
    return fieldMessages.join(" ");
  }

  return error?.message || fallback;
};

export default getApiErrorMessage;
